import { Component } from '@angular/core';
import { soundpostAccountingEntryLineDimensionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Accounting Entry Line Dimensions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostaccountingentrylinedimension-form',
    templateUrl: './soundpostaccountingentrylinedimension.form.component.html'
})
export class soundpostAccountingEntryLineDimensionFormComponent extends BaseFormComponent {
    public record!: soundpostAccountingEntryLineDimensionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

